import {
    GET_TEACHING_RESOURCES_REQUEST,
    GET_TEACHING_RESOURCES_SUCCESS,
    GET_TEACHING_RESOURCES_FAILURE,
} from '../actions';


const initialState = {};

const TeachingResourcesReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_TEACHING_RESOURCES_REQUEST:
            return Object.assign({},state, {asyncStatus:  'PENDING'});
        case GET_TEACHING_RESOURCES_SUCCESS:
            return Object.assign({},state, {asyncStatus:  'SUCCESS', data: {...state.data, [action.request]: action.payload}});
        case GET_TEACHING_RESOURCES_FAILURE:
            return Object.assign({},state, {asyncStatus:  'FAILURE', data: action.payload});
        default:
            return state;
    }
};

export default TeachingResourcesReducer;